// extracted by mini-css-extract-plugin
var _1 = "Modal-moduleModal__c1dw1";
var _2 = "Modal-modulehidden__gbFh6";
var _3 = "Modal-modulemask__ngv1Q";
var _4 = "Modal-moduletransparent__ibqlo";
export { _1 as "Modal", _2 as "hidden", _3 as "mask", _4 as "transparent" }
